import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CreateActivityModal, EditActivityModal, ActivityListFilters } from "@modules/activities/components";

import {  useActivityList } from "./controller";
import { useActivityListColumns } from "./columns";

export const ActivityList = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createActivityModalRef,
    editActivityModalRef,
    setSelectedRows,
    refetch,
    translate,
  } =  useActivityList();

  const columns = useActivityListColumns(refetch, translate, editActivityModalRef);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <ActivityListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="activities.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createActivityModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateActivityModal
        onComplete={() => {
          refetch();
          setSelectedRows([]);
        }}
        modalRef={createActivityModalRef}
      />
      <EditActivityModal
        onComplete={() => {
          refetch();
          setSelectedRows([]);
        }}
        modalRef={editActivityModalRef}
      />
    </List>
  );
});
